import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/main/api.service';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { Storage } from '@ionic/storage';
import { environment } from 'src/environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/authentication/auth.service';
import { GlobalService } from 'src/app/services/main/global.service';

@Component({
  selector: 'app-customagent',
  templateUrl: './customagent.component.html',
  styleUrls: ['./customagent.component.css']
})
export class CustomagentComponent extends BaseCrudComponent implements OnInit {
  statusList = [];
  userList = [];
  userListCombinated = [];
  constructor(
    public globalService: GlobalService,
    public srv: ApiService,
    public modalService: NgbModal,
    public storage: Storage,
    public router: Router,
    private _authService: AuthService,
    public translate?: TranslateService,
  ) {
    super(srv, modalService, storage, router);
    this.search_fields = ['Name','Description','RUC'];  
    
  }

  async ngOnInit() {
    await super.ngOnInit();
    await this.getInitialData();
    this.user = this._authService.getUserLogged();
    this.permissionList = this._authService.GetPermissionsByModule("CX_CA");
    await this.getNotificationAP(this.user.sub);
    await this.getNotificationAC(this.user.sub);
    await this.getNotificationCXP(this.user.sub);
    await this.getNotificationCP(this.user.sub);
    await this.getNotificationCA(this.user.sub);
  }

  public async getInitialData() {

    this.messageShowLoading();
    
    this.url = environment.Global.API_GET_ALL_AG;
    await this.srv.get(this.url).toPromise().then(result => {
      if (result.Status) {
        this.rows = result.Object;
        this.rawdata = result.Object;
        if( Array.isArray(this.rows) ){
          this.pageTotal = this.rows.length;
        }
      }  else {
        this.messageDialog(result.Message, '', 'error');
      }
      this.closeMessageDialog();
    })
    await this.getUserExternalUnAssigned();
  }

  public createForm(object:any): boolean{
    let myForm:any = {};
    myForm = new FormGroup({
      'Name': new FormControl(object.Name, [Validators.required]),
      'Description': new FormControl(object.Description, [Validators.required]),
      'RUC': new FormControl(object.RUC, [Validators.required]),
    });
    return myForm.valid;
  }

  public searchData(event) {
    this.search = event;
    this.filterAll();
  }

  public openCreateModal(modal) {
    this.isCreating = false;
    this.c_obj['UserByAgent'] = [];
    this.modalService.open(modal, { backdrop: 'static', keyboard: false,  size: 'lg', centered:true });
  }

  public createItem(modal, object) {
    this.isCreating = true;
    if (!this.createForm(object)) {
      this.isCreating = false;
      return this.errorFormMessage();
    }
    let users = [];
    if (object.UserByAgent.length > 0) {
      object.UserByAgent.forEach(element => {
        let data = {
          UserId: Number(element)
        }
        users.push(data)
      });
    }
    this.obj = {
      Name: object.Name,
      Description: object.Description,
      RUC: object.RUC,
      CreatorUser: this.user.name,
      UserByAgent: users
    }
    this.url = environment.Global.API_CREATE_AG;
    this.srv.post(this.url, this.obj).toPromise().then( result => {
      if(result.Status) {
        this.messageDialog(result.Message, '', 'success');
        this.clearData();       
      } else {
        this.messageDialog(result.Message, '', 'error');
      }
      this.isCreating = false;
      this.closeModal(modal);
    }, err => {
      this.messageDialog(err,'','error');
      this.isCreating = false;
    })
  }

  public clickOnCheck(event, id) {
    if ( event.target.checked ) {
      this.changeStatus('1', id);
    }else {
      this.changeStatus('2', id);
    }
  }

  public changeStatus(value, id) {
    this.url = environment.Global.API_UPDATE_STATUS_AG;
    this.obj = {
      AgentId: id,
      Status: value,  
      ModifierUser: this.user.name,
      DeleteUser: this.user.name
    }
    this.srv.post(this.url,this.obj).toPromise().then(result => {
      if(result.Status) {
        this.messageDialog(result.Message, '', 'success');
      }  else {
        this.messageDialog(result.Message, '', 'error');
      }
    }, err => {
      this.messageDialog(err,'','error');
    })
  }

  public openUpdateModal(modal, object) {
    this.isUpdating = false;
    this.u_obj = JSON.parse(JSON.stringify(object));
    this.u_obj['UpdateUserByAgent'] = [];
    this.modalService.open(modal, { backdrop: 'static', keyboard: false,  size: 'lg', centered:true });
    this.getUserCombinated(object.AgentId);
    if (this.u_obj['UserByAgent'].length > 0) {
      this.u_obj['UserByAgent'].forEach(element => {
        this.u_obj['UpdateUserByAgent'].push(element.UserId.toString());
      });
    }
  }

  public updateItem(modal, object) {
    this.isUpdating = true;
    if (!this.createForm(object)) {
      this.isUpdating = false;
      return this.errorFormMessage();
    }
    let users = [];
    if (object.UpdateUserByAgent.length > 0) {
      object.UpdateUserByAgent.forEach(element => {
        let data = {
          UserId: Number(element)
        }
        users.push(data)
      });
    }
    this.obj = {
      AgentId: object.AgentId,
      Name: object.Name,
      Description: object.Description,
      RUC: object.RUC,
      ModifierUser: this.user.name,
      UserByAgent: users
    }
    this.url = environment.Global.API_UPDATE_AG;
    this.srv.post(this.url, this.obj).toPromise().then(result => {
      if (result.Status) {
        this.messageDialog(result.Message, '', 'success');
        this.clearData();
        this.closeModal(modal);
      }  else {
        this.messageDialog(result.Message, '', 'error');
      }
      this.isUpdating = false;
    }, err => {
      this.messageDialog(err,'','error');
      this.isUpdating = false;
    })
  }

  public async getUserExternalUnAssigned() {
    this.url = environment.Global.API_GET_USER_NASS;
    await this.srv.get(this.url).toPromise().then(result => {
      if (result.Status) {
        if (result.Object.length > 0) {
          this.userList = result.Object;
        }
      }
    })
  }

  public async getUserCombinated(AgentId) {
    this.url = environment.Global.API_GET_USER_COMB + AgentId + '/1';
    await this.srv.get(this.url).toPromise().then(result => {
      if (result.Status) {
        if (result.Object.length > 0) {
          this.userListCombinated = result.Object;
        }
      }
    })
  }

}
